module.exports = __webpack_public_path__ + "static/media/02B.59e457f1.png";